/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Requester_Buyer_ContactInputs */

const en_claim_requester_buyer_contact = /** @type {(inputs: Claim_Requester_Buyer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A buyer contact of the customer`)
};

/**
* | output |
* | --- |
* | "A buyer contact of the customer" |
*
* @param {Claim_Requester_Buyer_ContactInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_requester_buyer_contact = /** @type {((inputs?: Claim_Requester_Buyer_ContactInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Requester_Buyer_ContactInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_requester_buyer_contact(inputs)
});